<script setup lang="ts">
  import { computed } from 'vue';
  import type { FormElement, UrlInputProperties } from '../../../model/form.types';
  import { useFormBuilderDisplayInput } from '../../../model/useFormBuilderDisplayInput';
  import { Tooltip } from '@/shared/ui';

  interface Props {
    element: FormElement & { properties: UrlInputProperties };
  }

  const props = defineProps<Props>();

  const { inputValue, isLabelLeft, inputClasses, labelClasses, labelStyles, containerStyles, isEditable } =
    useFormBuilderDisplayInput(() => props.element, 'URL_INPUT');

  const placeholderText = computed(() => props.element.properties.placeholder);

  const logFieldNameAttr = computed(() => {
    return props.element.properties.logFieldName || undefined;
  });
</script>

<script lang="ts">
  export const urlPattern =
    /^(https?:\/\/)?([\w-]+\.)+[a-zA-Z]{2,}(\/[\w\-.~:/?#[\]@!$&'()*+,;=]*)?$/;
</script>

<template>
  <div
    class="form-builder-simple-input"
    :class="{ 'label-left': isLabelLeft }"
    :style="containerStyles"
  >
    <Tooltip
      v-if="element.properties.tooltip && element.properties.label"
      :content="element.properties.tooltip"
    >
      <label
        :for="`input-${element.id}`"
        :class="labelClasses"
        :style="labelStyles"
      >
        {{ element.properties.label }}
      </label>
    </Tooltip>
    <label
      v-else
      :for="`input-${element.id}`"
      :class="labelClasses"
      :style="labelStyles"
    >
      {{ element.properties.label }}
    </label>
    <input
      :id="`input-${element.id}`"
      :value="inputValue"
      type="url"
      :name="element.properties.name"
      :placeholder="placeholderText"
      :pattern="urlPattern.source"
      :required="element.properties.required"
      :aria-label="element.properties.label || element.properties.name"
      :readonly="!isEditable"
      :class="inputClasses"
      :data-log-field-name="logFieldNameAttr"
    >
  </div>
</template>

<style scoped>
  @import './form-builder-simple-input.css';
</style>
